import { Box, Heading, Icon, Spinner } from '@chakra-ui/react';

interface BoxLinkProps {
  name: string;
  onPress: () => void;
  color: string;
  icon: React.ElementType;
  to?: string;
  isLoading?: boolean;
  /** Esmaece o box sem bloquear o clique, para que o handler possa explicar o porquê. */
  isInactive?: boolean;
}

export function BoxLink({ name, onPress, color, icon, isLoading, isInactive }: BoxLinkProps) {
  return (
    <Box
      as="button"
      onClick={onPress}
      disabled={isLoading}
      borderRadius="lg"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="flex-start"
      backgroundColor="white"
      overflow="hidden"
      padding="20px"
      boxShadow="2px 2px 6px 0px #0000002E"
      width="100%"
      opacity={isLoading || isInactive ? 0.7 : 1}
    >
      {isLoading ? (
        <Spinner color={color} boxSize={6} marginBottom="10px" />
      ) : (
        <Icon color={color} as={icon} boxSize={6} marginBottom="10px" />
      )}
      <Heading color="#292927" fontWeight="500" textAlign="left" fontSize="16px">
        {name}
      </Heading>
    </Box>
  );
}
